import { render, staticRenderFns } from "./ListOrganizations.vue?vue&type=template&id=8afed11c&scoped=true"
import script from "./ListOrganizations.vue?vue&type=script&lang=js"
export * from "./ListOrganizations.vue?vue&type=script&lang=js"
import style0 from "./ListOrganizations.vue?vue&type=style&index=0&id=8afed11c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8afed11c",
  null
  
)

export default component.exports